module.exports = __webpack_public_path__ + "assets/pdf/I04-en-seasonal-forecast.cd46c6a7.pdf";